import {File} from '../dms/dms.types';

// basci travel object
export class BasicTravel {
    id: number | null;
    offer: number | null;
    code: string;
    at: number;
    active: boolean;
    supplier: string;
    name: string;
    type: string;
    typeShort: string;
    typeName: string;
    order: string;
    durType: string;
    durTypeName: string;
    durVal: number;
    desc: string;
    firstStart: string;
    firstEnd: string;
    fromPrice: number | null;
    tags: string[];
    accommodation: BasicSimpleTravelAccommodation;
    header: {
    };
    subHeader: {
    };
    // subText: {
    //     [x: string]: string;
    // };
    subText1: {
    };
    shortText: {
    };
    files: File[];
  }

  export class BasicSimpleTravelAccommodation {
    id: number | null;
    category: number | null;
    roomTypes: SimpleTravelRoomType[];
  }


  export class SimpleTravelRoomType {
    id: number | null;
    roomType: string;
    prices: SimpleTravelRoomTypePrice[];
}

export class SimpleTravelRoomTypePrice {
    id: number | null;
    start: string;
    price: number;
    active: boolean;
    deleteEntry: boolean;
}





// WEBPACK FOOTER //
// ./src/app/product/basic.travel.ts